import { makeStyles } from "@material-ui/core";

export default makeStyles(
  () => ({
    form: {
      maxWidth: 400,
      margin: [10, "auto"],
    },
  }),
  { name: "ChangeName" },
);
